import { WebApiService } from '../../../plugins/webApiService'
import { SendRequestModel } from '../../../plugins/models/SendRequestModel'
import GetCountEmployeesUserRequest from '../../../projects/performers/i-service/model/request/GetCountEmployeesUserRequest';
import GetEmployeesListRequest from '../../../projects/performers/i-service/model/request/GetEmployeesListRequest';
import GetEmployeesForManagerListWithAccessRequest from '../../../projects/performers/i-service/model/request/GetEmployeesForManagerListWithAccessRequest';
import GetEmployeesDetailForManagerListRequest from '../../../projects/performers/i-service/model/request/GetEmployeesDetailForManagerListRequest';
import PerformerTaskDaysRequest from '../../../projects/performers/i-service/model/request/PerformerTaskDaysRequest';
import WsResponseModelT from '../../../schema-builder/server/models/WsResponseModelT';
import GetCountEmployeesUserResponse from '../../../projects/performers/i-service/model/response/GetCountEmployeesUserResponse';
import GetEmployeesListResponse from '../../../projects/performers/i-service/model/response/GetEmployeesListResponse';
import GetEmployeesForManagerListWithAccessResponse from '../../../projects/performers/i-service/model/response/GetEmployeesForManagerListWithAccessResponse';
import GetEmployeesDetailForManagerListResponse from '../../../projects/performers/i-service/model/response/GetEmployeesDetailForManagerListResponse';
import PerformerTaskDaysResponse from '../../../projects/performers/i-service/model/response/PerformerTaskDaysResponse';

/**
 * * Сервис команды
 */
export default class EmployeeService {
	private url?: string;
	private cookieName: string;
	private appWebSettingsPath?: string;
	private apiUrlProperty?: string;

	
	constructor(url?: string, cookieName?: string, appWebSettingsPath?: string, apiUrlProperty?: string) {
		this.url = url;
		this.cookieName = cookieName ?? "Auth-Token";
		this.appWebSettingsPath = appWebSettingsPath && [location.host, appWebSettingsPath].join("/");
		this.apiUrlProperty = apiUrlProperty;
	}

	/**
	 * * Получение количества людей состоящих в команде пользователя
	 */
	async GetCountEmployeesUser(request: GetCountEmployeesUserRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EmployeeService',
			Method: 'GetCountEmployeesUser',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список сотрудников
	 */
	async GetEmployeesForManagerList(request: GetEmployeesListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EmployeeService',
			Method: 'GetEmployeesForManagerList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получить список сотрудников с доступами
	 */
	async GetEmployeesForManagerListWithAccess(request: GetEmployeesForManagerListWithAccessRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EmployeeService',
			Method: 'GetEmployeesForManagerListWithAccess',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка сотрудников с прикрепленными проектами
	 */
	async GetEmployeesDetailForManagerList(request: GetEmployeesDetailForManagerListRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EmployeeService',
			Method: 'GetEmployeesDetailForManagerList',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	/**
	 * * Получение списка сотрудников и их затраченное время на задачи по дням
	 */
	async GetPerformerTaskDaysReport(request: PerformerTaskDaysRequest) {
		const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
		const sendRequest = new SendRequestModel({
			ProjectName: 'Main',
			Controller: 'EmployeeService',
			Method: 'GetPerformerTaskDaysReport',
			Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
		})

		webApiService.send(sendRequest);
	}

	 // async methods
	/**
	 * * Получение количества людей состоящих в команде пользователя
	 */
	async getCountEmployeesUserAsync(request: GetCountEmployeesUserRequest): Promise<GetCountEmployeesUserResponse> {
		return new Promise<GetCountEmployeesUserResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EmployeeService',
				Method: 'GetCountEmployeesUser',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetCountEmployeesUserResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetCountEmployeesUserResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список сотрудников
	 */
	async getEmployeesForManagerListAsync(request: GetEmployeesListRequest): Promise<GetEmployeesListResponse> {
		return new Promise<GetEmployeesListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EmployeeService',
				Method: 'GetEmployeesForManagerList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetEmployeesListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetEmployeesListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получить список сотрудников с доступами
	 */
	async getEmployeesForManagerListWithAccessAsync(request: GetEmployeesForManagerListWithAccessRequest): Promise<GetEmployeesForManagerListWithAccessResponse> {
		return new Promise<GetEmployeesForManagerListWithAccessResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EmployeeService',
				Method: 'GetEmployeesForManagerListWithAccess',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetEmployeesForManagerListWithAccessResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetEmployeesForManagerListWithAccessResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка сотрудников с прикрепленными проектами
	 */
	async getEmployeesDetailForManagerListAsync(request: GetEmployeesDetailForManagerListRequest): Promise<GetEmployeesDetailForManagerListResponse> {
		return new Promise<GetEmployeesDetailForManagerListResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EmployeeService',
				Method: 'GetEmployeesDetailForManagerList',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<GetEmployeesDetailForManagerListResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as GetEmployeesDetailForManagerListResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

	/**
	 * * Получение списка сотрудников и их затраченное время на задачи по дням
	 */
	async getPerformerTaskDaysReportAsync(request: PerformerTaskDaysRequest): Promise<PerformerTaskDaysResponse> {
		return new Promise<PerformerTaskDaysResponse>(async (resolve, reject) => {
			const webApiService = await WebApiService.getInstance(this.url, this.cookieName, this.appWebSettingsPath, this.apiUrlProperty);
			const sendRequest = new SendRequestModel({
				ProjectName: 'Main',
				Controller: 'EmployeeService',
				Method: 'GetPerformerTaskDaysReport',
				Value: typeof(request) === 'object' ? JSON.stringify(request) : request,
				Callback: (response: WsResponseModelT<PerformerTaskDaysResponse>) => {
					const isGeneric = typeof response.IsSuccess == 'boolean'
					const result = response.IsSuccess ? response.Value : response

					if (!isGeneric || response.IsSuccess) resolve(result as PerformerTaskDaysResponse)
					else reject(result)
				}
			})

			webApiService.send(sendRequest);
		});
	}

}